import featureConstants from '../../constants/featureConstants';
import { isFeatureActive } from '../../redux/reducers/config/configReducer';
import isPayPalAvailable from './isPayPalAvailable';

export default function isBasketPayIn3Eligible(state) {

  if (!isFeatureActive(state, featureConstants.PAYPAL_PAY_IN_THREE_ENABLED)) {
    return false;
  }

  if (!isPayPalAvailable(state)) {
    return false;
  }

  if (state.orderForm.amounts.outstandingBalanceRaw < 30 || state.orderForm.amounts.outstandingBalanceRaw > 2000) {
    return false;
  }

  return true;

}
